import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    fill: "currentColor",
    viewBox: "0 -70 640 640",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", { "stroke-width": "0" }),
    _createElementVNode("g", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    _createElementVNode("g", null, [
      _createElementVNode("path", { d: "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z" })
    ])
  ]))
}